const RECHARGE_BLOCK_SELECTOR = '.shopify-block.recharge-subscription-widget';
const RECHARGE_ELEMENT_NAME = 'recharge-subscription-widget';
const RECHARGE_WIDGET_SELECTOR = RECHARGE_ELEMENT_NAME;
const RECHARGE_SLOT_SELECTOR = '[data-recharge-widget-slot]';
const PRODUCT_FORM_SELECTOR = 'form[data-product-form]';
const LIQUID_SELLING_PLANS_SELECTOR = '[data-recharge-selling-plans]';
const RECHARGE_SELECTION_ROOT_CLASS = 'rc-selection__root';
const RECHARGE_SELECTION_ROOT_SELECTOR = `.${RECHARGE_SELECTION_ROOT_CLASS}`;
const RECHARGE_SUBSCRIPTION_OPTION_SELECTOR = '.rc-purchase-option__subscription, [part~="rc-purchase-option__subscription"]';
const RECHARGE_ONETIME_OPTION_SELECTOR = '.rc-selection__onetime, [part~="rc-purchase-option__onetime"]';
const RECHARGE_REAL_PLAN_SELECT_SELECTOR = '.rc-plans-dropdown__select, [part~="rc-plans-select"], select[name="rc_plan"]';
const RECHARGE_PRICE_SELECTOR = '.rc-purchase-option__price, [part~="rc-purchase-option__price"]';
const RECHARGE_DISCOUNTED_PRICE_SELECTOR = '.rc-purchase-option__discounted-price, [part~="rc-purchase-option__discounted-price"]';
const CUSTOM_FREQUENCY_WRAPPER_SELECTOR = '[data-wp-recharge-frequency-wrapper]';
const CUSTOM_FREQUENCY_SELECTOR = '[data-recharge-frequency-select]';
const SUBSCRIPTION_BENEFITS_SELECTOR = '[data-recharge-subscription-benefits]';
const RECHARGE_BENEFITS_SELECTOR = '[data-recharge-benefits]';
const RECHARGE_CONTENT_SELECTOR = '[data-recharge-content]';
const HYDRATION_POLL_MS = 100;
const HYDRATION_TIMEOUT_MS = 5000;
const PLAN_SYNC_RETRY_LIMIT = 12;
const SUBSCRIPTION_INPUT_SELECTOR = 'input[name="purchaseOption"]';
const SELLING_PLAN_INPUT_SELECTOR = '[data-recharge-selling-plan-input]';
const SELLING_PLAN_NAMED_INPUT_SELECTOR = '[name="selling_plan"]';

// Recharge renders its purchase controls inside shadow DOM, so theme CSS cannot
// style it directly. These rules are injected into the widget once it hydrates.
const SHADOW_STYLES = `
  :host {
    display: block;
    width: 100%;
  }

  .rc-widget__root,
  .${RECHARGE_SELECTION_ROOT_CLASS} {
    width: 100%;
    color: #333333;
    font-family: inherit;
  }

  .rc-purchase-option-group {
    min-width: 0;
    margin: 0;
    padding: 0;
    border: 0;
  }

  .rc-purchase-option-heading {
    margin: 0 0 16px;
    color: #333333;
    font-size: 18px;
    font-weight: 400;
    line-height: 1.2;
    letter-spacing: -0.03em;
  }

  .${RECHARGE_SELECTION_ROOT_CLASS} {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
    align-items: stretch;
  }

  .rc-purchase-option {
    position: relative;
    box-sizing: border-box;
    min-width: 0;
    height: 85px;
    min-height: 0;
    padding: 15px;
    border: 1px solid #dadee2;
    border-radius: 12px;
    background: #ffffff;
    overflow: hidden;
  }

  .rc-purchase-option:not(:last-child) {
    margin-bottom: 0;
  }

  .rc-purchase-option__subscription {
    order: 1;
  }

  .rc-selection__onetime {
    order: 2;
  }

  .rc-purchase-option[rc-selected] {
    border: 2px solid #333333;
    padding: 14px;
  }

  /* The radio input itself is visually hidden, so surface keyboard focus on
     the option card. Radio groups are a single tab stop: Tab lands on the
     checked option, then Arrow keys move between options. */
  .rc-purchase-option:has(.rc-purchase-option__input:focus-visible) {
    outline: 2px solid #333333;
    outline-offset: 2px;
  }

  .rc-purchase-option__label {
    display: flex;
    min-width: 0;
    gap: 8px;
    align-items: flex-start;
    justify-content: space-between;
    padding: 0;
    cursor: pointer;
  }

  .rc-purchase-option__selector {
    display: flex;
    min-width: 0;
    gap: 8px;
    align-items: flex-start;
    color: #333333;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.2;
    letter-spacing: -0.01em;
    padding: 0;
  }

  .rc-purchase-option__checked-indicator {
    width: 16px;
    height: 16px;
    margin-top: 1px;
    flex: 0 0 16px;
    color: #333333;
  }

  .rc-purchase-option[rc-selected] .rc-purchase-option__checked-indicator,
  .rc-purchase-option[rc-selected] [part~="rc-purchase-option__checked-indicator"] {
    color: #9fbecf !important;
    border-color: #9fbecf !important;
  }

  .rc-purchase-option__input {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip: rect(0 0 0 0);
  }

  .rc-purchase-option__prices {
    display: flex;
    min-width: 0;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
    color: #bababa;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.2;
    letter-spacing: -0.01em;
  }

  .rc-selection__onetime .rc-purchase-option__label {
    flex-direction: column;
  }

  .rc-selection__onetime .rc-purchase-option__prices {
    padding-left: 32px;
    margin-left: 0;
  }

  .rc-purchase-option__subscription .rc-purchase-option__label {
    display: grid !important;
    grid-template-columns: minmax(0, 1fr);
    gap: 4px;
  }

  .rc-purchase-option__subscription .rc-purchase-option__prices {
    padding-left: 32px !important;
    margin-left: 0 !important;
  }

  .rc-purchase-option__badge {
    position: static !important;
    inset: auto !important;
    z-index: 1 !important;
    box-sizing: border-box !important;
    display: inline-flex !important;
    width: fit-content !important;
    min-width: 0 !important;
    max-width: max-content !important;
    height: 30px !important;
    min-height: 30px !important;
    max-height: 30px !important;
    flex: 0 0 auto !important;
    align-items: center !important;
    justify-content: center !important;
    padding: 8px 12px !important;
    border-radius: 40px !important;
    background: #9fbecf !important;
    color: #333333 !important;
    font-size: 14px !important;
    font-weight: 600 !important;
    line-height: 1 !important;
    letter-spacing: -0.01em !important;
    text-transform: uppercase !important;
    white-space: nowrap !important;
    pointer-events: none !important;
  }

  .rc-purchase-option__subscription .rc-purchase-option__prices {
    display: flex !important;
    width: 100%;
    flex-wrap: nowrap !important;
    gap: 8px !important;
    align-items: center !important;
  }

  .rc-purchase-option__subscription .rc-purchase-option__original-price,
  .rc-purchase-option__subscription [part~="rc-purchase-option__original-price"],
  [part~="rc-purchase-option__subscription"] [part~="rc-purchase-option__original-price"] {
    display: none !important;
  }

  .rc-purchase-option__subscription .rc-purchase-option__discounted-price,
  .rc-purchase-option__subscription [part~="rc-purchase-option__discounted-price"],
  [part~="rc-purchase-option__subscription"] [part~="rc-purchase-option__discounted-price"] {
    display: inline-flex !important;
    color: #bababa !important;
    text-decoration: none !important;
  }

  .rc-selection__onetime .rc-purchase-option__price,
  .rc-selection__onetime [part~="rc-purchase-option__price"] {
    color: #bababa !important;
    text-decoration: none !important;
  }

  .rc-subscription-benefits {
    display: grid;
    gap: 12px;
    margin: 20px 0 0;
    padding: 0;
    list-style: none;
    color: #333333;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.2;
    letter-spacing: -0.01em;
  }

  .rc-subscription-benefits li {
    display: flex;
    min-width: 0;
    gap: 9px;
    align-items: flex-start;
  }

  .rc-subscription-benefits li::before {
    content: "";
    width: 15px;
    height: 13px;
    flex: 0 0 15px;
    margin-top: 1px;
    background: url("data:image/svg+xml,%3Csvg width='15' height='13' viewBox='0 0 15 13' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M13.8438 6.40625L8.34375 11.9062C8.15625 12.0938 7.8125 12.0938 7.625 11.9062C7.4375 11.7188 7.4375 11.375 7.625 11.1875L12.2812 6.53125H0.5C0.21875 6.53125 0 6.3125 0 6.03125C0 5.78125 0.21875 5.53125 0.5 5.53125H12.2812L7.625 0.90625C7.4375 0.71875 7.4375 0.375 7.625 0.1875C7.8125 0 8.15625 0 8.34375 0.1875L13.8438 5.6875C14.0312 5.875 14.0312 6.21875 13.8438 6.40625Z' fill='%239FBECF'/%3E%3C/svg%3E") center / contain no-repeat;
  }

  .rc-purchase-option__sub-container,
  [part~="rc-purchase-option__sub-container"] {
    margin-top: 16px !important;
  }

  .rc-widget__root[data-wp-custom-frequency-active] .rc-purchase-option__sub-container,
  .rc-widget__root[data-wp-custom-frequency-active] [part~="rc-purchase-option__sub-container"] {
    display: none !important;
  }

  .rc-widget__root[data-wp-custom-frequency-active] [data-recharge-frequency-wrapper]:not([data-wp-recharge-frequency-wrapper]) {
    display: none !important;
  }

  .rc-subscription-frequency {
    position: relative;
    display: block;
    margin-top: 20px;
  }

  .rc-subscription-frequency[hidden] {
    display: none !important;
  }

  .rc-subscription-frequency__select {
    appearance: none;
    width: 100% !important;
    min-height: 46px !important;
    padding: 14px 28px 14px 18px !important;
    border: 1px solid #333333 !important;
    border-radius: 62px !important;
    background-color: #ffffff !important;
    color: #333333 !important;
    font-family: "Chivo Mono", "Chivo_Mono", monospace !important;
    font-size: 14px !important;
    font-weight: 600 !important;
    line-height: 1.2 !important;
    letter-spacing: -0.01em !important;
    cursor: pointer !important;
  }

  .rc-subscription-frequency__select:focus,
  .rc-subscription-frequency__select:focus-visible {
    border-color: #333333 !important;
    box-shadow: none !important;
    outline: none !important;
  }

  .rc-subscription-frequency::after {
    content: "";
    position: absolute;
    right: 18px;
    top: 50%;
    width: 10px;
    height: 8px;
    background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='7' viewBox='0 0 10 7' fill='none'%3E%3Cpath d='M0.707031 0.707153L4.70703 4.70715L8.70703 0.707153' stroke='%23333333' stroke-width='2'/%3E%3C/svg%3E") center / contain no-repeat;
    pointer-events: none;
    transform: translateY(-50%);
  }

  rc-selling-plans::part(rc-plans-dropdown) {
    width: 100% !important;
  }

  rc-selling-plans::part(rc-plans__label) {
    display: none !important;
  }

  rc-selling-plans::part(rc-plans-select) {
    width: 100% !important;
    min-height: 46px !important;
    padding: 14px 28px 14px 18px !important;
    border: 1px solid #333333 !important;
    border-radius: 62px !important;
    background-color: #ffffff !important;
    color: #333333 !important;
    font-size: 14px !important;
    font-weight: 600 !important;
    line-height: 1.2 !important;
    letter-spacing: -0.01em !important;
    cursor: pointer !important;
  }

  .rc-learn-more {
    display: none;
  }

  @media (max-width: 520px) {
    .${RECHARGE_SELECTION_ROOT_CLASS} {
      grid-template-columns: 1fr;
    }
  }
`;

const applyShadowStyles = (shadowRoot) => {
  if (shadowRoot.wpRechargeStylesApplied || shadowRoot.querySelector('[data-willpowders-recharge-style]')) return;

  shadowRoot.wpRechargeStylesApplied = true;

  if ('adoptedStyleSheets' in shadowRoot && 'CSSStyleSheet' in window) {
    const sheet = new CSSStyleSheet();
    sheet.replaceSync(SHADOW_STYLES);
    shadowRoot.adoptedStyleSheets = [...shadowRoot.adoptedStyleSheets, sheet];
    return;
  }

  const style = document.createElement('style');
  style.dataset.willpowdersRechargeStyle = 'true';
  style.textContent = SHADOW_STYLES;
  shadowRoot.append(style);
};

// Shopify app blocks render outside the product form by default. Moving the
// Recharge block into this slot lets our ATC handler submit the selected plan.
const moveRechargeBlockIntoProductForm = () => {
  const slot = document.querySelector(RECHARGE_SLOT_SELECTOR);
  const rechargeBlock = document.querySelector(RECHARGE_BLOCK_SELECTOR);

  if (!slot || !rechargeBlock || slot.contains(rechargeBlock)) return;

  rechargeBlock.style.display = 'block';
  rechargeBlock.style.width = '100%';
  slot.append(rechargeBlock);
};

const getConfiguredContent = () => {
  const contentScript = document.querySelector(RECHARGE_CONTENT_SELECTOR);

  if (!contentScript?.textContent) return {};

  try {
    const content = JSON.parse(contentScript.textContent);

    return content && typeof content === 'object' ? content : {};
  } catch {
    return {};
  }
};

const formatFrequencyOptionText = (text) => {
  const intervalMatch = text.match(/\b(\d+)\s+month/i);

  if (!intervalMatch) return text.trim();

  const interval = Number(intervalMatch[1]);
  const content = getConfiguredContent();

  if (interval === 1) {
    return content.frequencyEveryMonth || text.trim();
  }

  return content.frequencyEveryMonths?.replace('{{ count }}', interval) || text.trim();
};

const getLiquidSellingPlans = () => {
  const sellingPlansScript = document.querySelector(LIQUID_SELLING_PLANS_SELECTOR);

  if (!sellingPlansScript?.textContent) return [];

  try {
    const sellingPlans = JSON.parse(sellingPlansScript.textContent);

    if (!Array.isArray(sellingPlans)) return [];

    return sellingPlans;
  } catch {
    return [];
  }
};

const getConfiguredPlanOptions = () => {
  const liquidSellingPlans = getLiquidSellingPlans();

  if (liquidSellingPlans.length) {
    return liquidSellingPlans.map((plan) => ({
      text: formatFrequencyOptionText(plan.name),
      value: String(plan.id)
    }));
  }

  if (!Array.isArray(window.SubscriptionWidgetConfig?.shopifyPlans)) return [];

  return window.SubscriptionWidgetConfig.shopifyPlans.map((plan) => ({
    text: formatFrequencyOptionText(plan.name),
    value: String(plan.id)
  }));
};

const getConfiguredBenefits = () => {
  const benefitsScript = document.querySelector(RECHARGE_BENEFITS_SELECTOR);

  if (!benefitsScript?.textContent) return [];

  try {
    const benefits = JSON.parse(benefitsScript.textContent);

    if (!Array.isArray(benefits)) return [];

    return benefits.map(benefit => String(benefit).trim()).filter(Boolean);
  } catch {
    return [];
  }
};

const injectHeading = (shadowRoot) => {
  const selectionRoot = shadowRoot.querySelector(RECHARGE_SELECTION_ROOT_SELECTOR);
  const headingText = getConfiguredContent().heading;

  if (!selectionRoot || !headingText || shadowRoot.querySelector('[data-recharge-option-heading]')) return;

  const heading = document.createElement('p');
  heading.className = 'rc-purchase-option-heading';
  heading.dataset.rechargeOptionHeading = 'true';
  heading.textContent = headingText;

  selectionRoot.insertAdjacentElement('beforebegin', heading);
};

const getRealPlanSelects = (shadowRoot) => {
  const lightDomSelects = [...shadowRoot.querySelectorAll(RECHARGE_REAL_PLAN_SELECT_SELECTOR)];
  const nestedSelects = [...shadowRoot.querySelectorAll('rc-selling-plans')]
    .map((sellingPlans) => sellingPlans.shadowRoot?.querySelector(RECHARGE_REAL_PLAN_SELECT_SELECTOR))
    .filter(Boolean);

  return [...lightDomSelects, ...nestedSelects];
};

const dispatchPlanChange = (select) => {
  select.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
  select.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
};

const syncRealPlanSelects = (shadowRoot, value) => {
  const realPlanSelects = getRealPlanSelects(shadowRoot);

  realPlanSelects.forEach((select) => {
    if (select.value !== value) {
      select.value = value;
    }

    dispatchPlanChange(select);
  });

  return realPlanSelects.length > 0;
};

const selectSubscriptionOption = (shadowRoot) => {
  const subscriptionOption = shadowRoot.querySelector(RECHARGE_SUBSCRIPTION_OPTION_SELECTOR);
  const subscriptionInput = subscriptionOption?.querySelector(SUBSCRIPTION_INPUT_SELECTOR);

  if (!subscriptionInput || subscriptionInput.checked) return;

  subscriptionInput.click();
};

const syncPlanWhenAvailable = (shadowRoot, value, attempt = 0) => {
  if (syncRealPlanSelects(shadowRoot, value)) return;
  if (attempt >= PLAN_SYNC_RETRY_LIMIT) return;

  window.setTimeout(() => {
    syncPlanWhenAvailable(shadowRoot, value, attempt + 1);
  }, HYDRATION_POLL_MS);
};

// The real Recharge dropdown is kept hidden, but still receives value changes
// so Recharge's own state and events stay in sync with our custom dropdown.
const syncCustomFrequencyValue = (shadowRoot, customSelect) => {
  const realPlanSelect = getRealPlanSelects(shadowRoot)[0];

  if (realPlanSelect) {
    customSelect.value = realPlanSelect.value;
  }
};

const getSelectedPlanValue = (shadowRoot) => {
  const customSelect = shadowRoot.querySelector(CUSTOM_FREQUENCY_SELECTOR);
  const realPlanSelect = getRealPlanSelects(shadowRoot)[0];
  const planOptions = getConfiguredPlanOptions();

  return customSelect?.value || realPlanSelect?.value || planOptions[0]?.value || '';
};

const isSubscriptionSelected = (shadowRoot) => {
  const subscriptionOption = shadowRoot.querySelector(RECHARGE_SUBSCRIPTION_OPTION_SELECTOR);
  const subscriptionInput = subscriptionOption?.querySelector(SUBSCRIPTION_INPUT_SELECTOR);

  return Boolean(subscriptionInput?.checked || subscriptionOption?.hasAttribute('rc-selected'));
};

const getSelectedPriceText = (shadowRoot) => {
  const subscriptionOption = shadowRoot.querySelector(RECHARGE_SUBSCRIPTION_OPTION_SELECTOR);
  const onetimeOption = shadowRoot.querySelector(RECHARGE_ONETIME_OPTION_SELECTOR);

  if (isSubscriptionSelected(shadowRoot)) {
    const subscriptionPrice = subscriptionOption?.querySelector(RECHARGE_DISCOUNTED_PRICE_SELECTOR)
      || subscriptionOption?.querySelector(RECHARGE_PRICE_SELECTOR);

    return subscriptionPrice?.textContent?.trim() || '';
  }

  const onetimePrice = onetimeOption?.querySelector(RECHARGE_PRICE_SELECTOR);

  return onetimePrice?.textContent?.trim() || '';
};

const updateFrequencyVisibility = (shadowRoot) => {
  const frequencyWrapper = shadowRoot.querySelector(CUSTOM_FREQUENCY_WRAPPER_SELECTOR);

  if (!frequencyWrapper) return;

  frequencyWrapper.hidden = !isSubscriptionSelected(shadowRoot);
};

// Our product form posts to Shopify cart/add.js, so mirror Recharge's selected
// purchase option into the form's hidden selling_plan input before ATC.
const syncProductFormSellingPlan = (widget, shadowRoot) => {
  const form = widget.closest(PRODUCT_FORM_SELECTOR);
  const sellingPlanInput = form?.querySelector(SELLING_PLAN_INPUT_SELECTOR);

  if (!sellingPlanInput) {
    return;
  }

  const nextValue = isSubscriptionSelected(shadowRoot) ? getSelectedPlanValue(shadowRoot) : '';

  if (sellingPlanInput.value !== nextValue) {
    sellingPlanInput.value = nextValue;
  }

  form.querySelectorAll(SELLING_PLAN_NAMED_INPUT_SELECTOR).forEach((input) => {
    if (input.value !== nextValue) {
      input.value = nextValue;
    }
  });
};

const injectBenefits = (shadowRoot) => {
  const selectionRoot = shadowRoot.querySelector(RECHARGE_SELECTION_ROOT_SELECTOR);
  const benefits = getConfiguredBenefits();

  if (!selectionRoot || !benefits.length || shadowRoot.querySelector(SUBSCRIPTION_BENEFITS_SELECTOR)) return;

  const benefitsList = document.createElement('ul');
  benefitsList.className = 'rc-subscription-benefits';
  benefitsList.dataset.rechargeSubscriptionBenefits = 'true';

  benefits.forEach((benefit) => {
    const item = document.createElement('li');
    item.textContent = benefit;
    benefitsList.append(item);
  });

  selectionRoot.insertAdjacentElement('afterend', benefitsList);
};

// Figma requires the frequency control below the benefits, but Recharge's
// native control cannot be moved cleanly out of its purchase-option box.
const renderFrequencySelector = (shadowRoot) => {
  const selectionRoot = shadowRoot.querySelector(RECHARGE_SELECTION_ROOT_SELECTOR);
  const planOptions = getConfiguredPlanOptions();

  if (!selectionRoot || !planOptions.length) return;

  let benefitsList = shadowRoot.querySelector(SUBSCRIPTION_BENEFITS_SELECTOR);

  if (!benefitsList) {
    injectBenefits(shadowRoot);
    benefitsList = shadowRoot.querySelector(SUBSCRIPTION_BENEFITS_SELECTOR);
  }

  let frequencyWrapper = shadowRoot.querySelector(CUSTOM_FREQUENCY_WRAPPER_SELECTOR);

  if (!frequencyWrapper) {
    frequencyWrapper = document.createElement('div');
    frequencyWrapper.className = 'rc-subscription-frequency';
    frequencyWrapper.dataset.wpRechargeFrequencyWrapper = 'true';
  }

  let customSelect = frequencyWrapper.querySelector(CUSTOM_FREQUENCY_SELECTOR);

  if (!customSelect) {
    customSelect = document.createElement('select');
    customSelect.className = 'rc-subscription-frequency__select';
    customSelect.dataset.rechargeFrequencySelect = 'true';
    customSelect.setAttribute('aria-label', 'Deliver every');
    customSelect.replaceChildren(...planOptions.map((option) => {
      const customOption = document.createElement('option');
      customOption.value = option.value;
      customOption.textContent = option.text;
      return customOption;
    }));
    customSelect.addEventListener('change', () => {
      const widget = customSelect.getRootNode().host;

      selectSubscriptionOption(shadowRoot);
      syncPlanWhenAvailable(shadowRoot, customSelect.value);
      syncProductFormSellingPlan(widget, shadowRoot);
      window.requestAnimationFrame(() => syncProductFormSellingPlan(widget, shadowRoot));
    });
    frequencyWrapper.replaceChildren(customSelect);
  }

  syncCustomFrequencyValue(shadowRoot, customSelect);

  const root = shadowRoot.querySelector('.rc-widget__root');
  root?.setAttribute('data-wp-custom-frequency-active', 'true');

  if (benefitsList && benefitsList.nextElementSibling !== frequencyWrapper) {
    benefitsList.insertAdjacentElement('afterend', frequencyWrapper);
  } else if (!benefitsList && selectionRoot.nextElementSibling !== frequencyWrapper) {
    selectionRoot.insertAdjacentElement('afterend', frequencyWrapper);
  }

  updateFrequencyVisibility(shadowRoot);
};

const moveSubscriptionBadge = (shadowRoot) => {
  const subscriptionOption = shadowRoot.querySelector(RECHARGE_SUBSCRIPTION_OPTION_SELECTOR);
  const badge = subscriptionOption?.querySelector('.rc-purchase-option__badge, [part~="rc-purchase-option__badge"]');
  const prices = subscriptionOption?.querySelector('.rc-purchase-option__prices, [part~="rc-purchase-option__prices"]');

  if (!badge || !prices || prices.contains(badge)) return;

  prices.append(badge);
};

// rc-radio-icon has its own shadow root and uses one color for ring and dot.
// Patch the nested SVG so the selected dot is blue while the outer ring is black.
const styleRadioIcons = (shadowRoot) => {
  shadowRoot.querySelectorAll('.rc-purchase-option__checked-indicator, [part~="rc-purchase-option__checked-indicator"]').forEach((icon) => {
    const iconShadowRoot = icon.shadowRoot;
    const checkedIcon = iconShadowRoot?.querySelector('.rc-checked-icon');

    if (!checkedIcon) return;

    const outerStroke = checkedIcon.querySelector('rect[stroke]');
    const innerCircle = checkedIcon.querySelector('circle');

    outerStroke?.setAttribute('stroke', '#333333');
    innerCircle?.setAttribute('fill', '#9fbecf');
  });
};

const getRechargeSelectionState = (shadowRoot) => {
  const subscriptionSelected = isSubscriptionSelected(shadowRoot);

  return {
    isSubscription: subscriptionSelected,
    priceText: getSelectedPriceText(shadowRoot),
    sellingPlanId: subscriptionSelected ? getSelectedPlanValue(shadowRoot) : ''
  };
};

const dispatchStickyAtcUpdate = (shadowRoot) => {
  document.dispatchEvent(new CustomEvent('recharge:purchase-option-change', {
    detail: getRechargeSelectionState(shadowRoot)
  }));

  if (typeof window.updateStickyBasket === 'function') {
    window.updateStickyBasket();
  }
};

const bindRechargeEvents = (widget, shadowRoot) => {
  if (widget.dataset.rechargeEventsBound === 'true') return;

  widget.dataset.rechargeEventsBound = 'true';
  widget.addEventListener('planChange', () => {
    syncProductFormSellingPlan(widget, shadowRoot);
    updateFrequencyVisibility(shadowRoot);
    dispatchStickyAtcUpdate(shadowRoot);
  });

  shadowRoot.addEventListener('change', (event) => {
    if (event.target?.matches?.(`${SUBSCRIPTION_INPUT_SELECTOR}, ${CUSTOM_FREQUENCY_SELECTOR}, .rc-plans-select`)) {
      syncProductFormSellingPlan(widget, shadowRoot);
      updateFrequencyVisibility(shadowRoot);
      dispatchStickyAtcUpdate(shadowRoot);
    }
  });
};

// Recharge can rerender chunks of its shadow DOM after selection or plan
// changes. Re-run the enhancements on mutation, throttled to one animation frame.
const enhanceRechargeWidget = (widget, shadowRoot) => {
  applyShadowStyles(shadowRoot);
  injectHeading(shadowRoot);
  moveSubscriptionBadge(shadowRoot);
  styleRadioIcons(shadowRoot);
  injectBenefits(shadowRoot);
  renderFrequencySelector(shadowRoot);
  syncProductFormSellingPlan(widget, shadowRoot);
  updateFrequencyVisibility(shadowRoot);
  dispatchStickyAtcUpdate(shadowRoot);
  bindRechargeEvents(widget, shadowRoot);
};

const bindRechargeObserver = (widget, shadowRoot) => {
  if (widget.dataset.rechargeObserverBound === 'true') return;

  let animationFrame = null;

  const observer = new MutationObserver(() => {
    if (animationFrame) return;

    animationFrame = window.requestAnimationFrame(() => {
      animationFrame = null;
      enhanceRechargeWidget(widget, shadowRoot);
    });
  });

  observer.observe(shadowRoot, {
    childList: true,
    subtree: true
  });

  widget.dataset.rechargeObserverBound = 'true';
};

const hydrateRechargeWidget = (widget) => {
  const shadowRoot = widget.shadowRoot;

  if (!shadowRoot) return false;
  if (!shadowRoot.querySelector(RECHARGE_SELECTION_ROOT_SELECTOR)) return false;

  enhanceRechargeWidget(widget, shadowRoot);
  bindRechargeObserver(widget, shadowRoot);

  return true;
};

// The custom element and its shadow DOM arrive asynchronously, so poll briefly
// after definition to catch the rendered purchase controls.
const initRechargeWidget = () => {
  moveRechargeBlockIntoProductForm();

  const widgets = document.querySelectorAll(RECHARGE_WIDGET_SELECTOR);
  if (!widgets.length) return;

  const hydrateWidgets = () => {
    widgets.forEach((widget) => {
      if (hydrateRechargeWidget(widget)) return;

      const interval = window.setInterval(() => {
        if (hydrateRechargeWidget(widget)) {
          window.clearInterval(interval);
        }
      }, HYDRATION_POLL_MS);

      window.setTimeout(() => window.clearInterval(interval), HYDRATION_TIMEOUT_MS);
    });
  };

  if (customElements.get(RECHARGE_ELEMENT_NAME)) {
    hydrateWidgets();
  } else {
    const hydrateWhenDefined = async () => {
      await customElements.whenDefined(RECHARGE_ELEMENT_NAME);
      hydrateWidgets();
    };

    hydrateWhenDefined();
  }
};

export default initRechargeWidget;
